import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SmartMatchingQuestion from "./SmartMatchingQuestion";
import { Button } from "primereact/button";
import * as translateService from "../../../../localization/translateService";

const TRANSLATION_KEYS = {
  CONFIRMATION: "SMART_MATCHING.MODAL.CONFIRMATION",
  YES: "BUTTON.YES",
  NO: "BUTTON.NO",
  CONFIRM_DESCRIPTION: "SMART_MATCHING.MODAL.CONFIRM_DESCRIPTION",
  SKIP_CONFIRMATION_TITLE: "SMART_MATCHING.MODAL.SKIP_CONFIRMATION_TITLE",
  SKIP_CONFIRMATION_DESCRIPTION: "SMART_MATCHING.MODAL.SKIP_CONFIRMATION_DESCRIPTION",
};

export default function SmartMatchingModal({ props, isModelOpen, closeModel, onViewResult }) {
  const [translations, setTranslations] = useState({
    CONFIRMATION: "",
    YES: "",
    NO: "",
    CONFIRM_DESCRIPTION: "",
    SKIP_CONFIRMATION_TITLE: "",
    SKIP_CONFIRMATION_DESCRIPTION: "",
  });
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [skipConfirmModalOpen, setSkipConfirmModalOpen] = useState(false);
  const [skipConfirmCallback, setSkipConfirmCallback] = useState(null);
  const [isNeedConfirmModal] = useState(true);

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        const [CONFIRMATION, YES, NO, CONFIRM_DESCRIPTION, SKIP_CONFIRMATION_TITLE, SKIP_CONFIRMATION_DESCRIPTION] =
          await translateService.translateAll([
            TRANSLATION_KEYS.CONFIRMATION,
            TRANSLATION_KEYS.YES,
            TRANSLATION_KEYS.NO,
            TRANSLATION_KEYS.CONFIRM_DESCRIPTION,
            TRANSLATION_KEYS.SKIP_CONFIRMATION_TITLE,
            TRANSLATION_KEYS.SKIP_CONFIRMATION_DESCRIPTION,
          ]);
        setTranslations({
          CONFIRMATION,
          YES: YES,
          NO: NO,
          CONFIRM_DESCRIPTION: CONFIRM_DESCRIPTION,
          SKIP_CONFIRMATION_TITLE: SKIP_CONFIRMATION_TITLE,
          SKIP_CONFIRMATION_DESCRIPTION: SKIP_CONFIRMATION_DESCRIPTION,
        });
      } catch (error) {
        //console.error("Failed to load translations:", error);
      }
    };
    loadTranslations();
  }, []);

  const handleOnCloseModal = () => {
    if (!isModelOpen) return;
    if (isNeedConfirmModal) {
      setConfirmModalOpen(true);
    } else {
      closeModel();
    }
  };

  const handleOnCloseConfirmModal = () => {
    if (!confirmModalOpen) return;
    setConfirmModalOpen(false);
  };

  const handleConfirmAcceptButton = () => {
    setConfirmModalOpen(false);
    closeModel();
  };

  const handleViewResult = () => {
    onViewResult();
  };

  const handleSkipRequest = (callback) => {
    setSkipConfirmCallback(() => callback);
    setSkipConfirmModalOpen(true);
  };

  const handleConfirmSkip = () => {
    setSkipConfirmModalOpen(false);
    if (skipConfirmCallback) {
      skipConfirmCallback();
      setSkipConfirmCallback(null);
    }
  };

  const handleCancelSkip = () => {
    setSkipConfirmModalOpen(false);
    setSkipConfirmCallback(null);
  };

  return (
    <div className="smart-matching-modal">
      <Dialog
        className="keduall-dialog keduall-question-container keduall-dialog-without-header"
        autoFocus={false}
        visible={isModelOpen}
        onHide={handleOnCloseModal}
        header={props.smartMatchingModalTitle}
        closable={false}
        blockScroll={true}
        baseZIndex="10001"
      >
        <div className="smart-matching-modal-content animate__animated animate__fadeInDown">
          <i className="pi pi-times close-btn" onClick={handleOnCloseModal}></i>
          <SmartMatchingQuestion props={props} onViewResult={handleViewResult} onSkipRequest={handleSkipRequest} />
        </div>
      </Dialog>
      <Dialog
        visible={confirmModalOpen}
        className="keduall-dialog keduall-question-confirm keduall-dialog-without-header"
        onHide={handleOnCloseConfirmModal}
        autoFocus={false}
        header={null}
        closable={false}
      >
        <div className="smart-matching-modal-content flex flex-column gap-3 animate__animated animate__fadeIn">
          <div className="flex flex-column gap-3">
            <i
              className="pi pi-times close-btn"
              onClick={handleOnCloseConfirmModal}
            ></i>
            <div className="keduall-typography heading-h4-semibold-600 text-default-txt text-center">
              {translations.CONFIRMATION}
            </div>
            <div className="keduall-typography heading-h6-normal-400 text-default-txt text-center">
              {translations.CONFIRM_DESCRIPTION}
            </div>
            <div className="p-0 flex justify-content-end align-items-center">
              <Button
                onClick={handleConfirmAcceptButton}
                className="keduall-buttons button-text-normal-secondary"
              >
                {translations.YES}
              </Button>
              <Button
                onClick={handleOnCloseConfirmModal}
                className="keduall-buttons button-filled-default-normal-primary"
              >
                {translations.NO}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={skipConfirmModalOpen}
        className="keduall-dialog keduall-question-confirm keduall-dialog-without-header"
        onHide={handleCancelSkip}
        autoFocus={false}
        header={null}
        closable={false}
      >
        <div className="smart-matching-modal-content flex flex-column gap-3 animate__animated animate__fadeIn">
          <div className="flex flex-column gap-3">
            <i
              className="pi pi-times close-btn"
              onClick={handleCancelSkip}
            ></i>
            <div className="keduall-typography heading-h4-semibold-600 text-default-txt text-center">
              {translations.SKIP_CONFIRMATION_TITLE}
            </div>
            <div className="keduall-typography heading-h6-normal-400 text-default-txt text-center">
              {translations.SKIP_CONFIRMATION_DESCRIPTION}
            </div>
            <div className="p-0 flex justify-content-end align-items-center">
              <Button
                onClick={handleCancelSkip}
                className="keduall-buttons button-text-normal-secondary"
              >
                {translations.NO}
              </Button>
              <Button
                onClick={handleConfirmSkip}
                className="keduall-buttons button-filled-default-normal-primary"
              >
                {translations.YES}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
